import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, CircleDollarSign, Mail, ShieldCheck } from "lucide-react";
import api, { formatApiErrorDetail } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "İstek başarısız");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-shell" data-testid="forgot-page">
      <aside className="auth-hero">
        <div className="auth-brand">
          <CircleDollarSign size={22} />
          <span>verafin</span>
        </div>
        <h1>Parolanızı unutmayı bize bırakın.</h1>
        <p>E-postanıza tek kullanımlık, süreli bir bağlantı gönderiyoruz. Bir saat içinde yeni parolanızı belirleyebilirsiniz.</p>
        <div className="auth-highlights">
          <div className="hl">
            <ShieldCheck size={17} />
            <span>Tek kullanımlık token — 1 saat geçerli</span>
          </div>
          <div className="hl">
            <Mail size={17} />
            <span>E-posta hiçbir zaman parolanızı istemez</span>
          </div>
        </div>
      </aside>

      <section className="auth-card">
        <Link to="/login" className="auth-back" data-testid="back-to-login">
          <ArrowLeft size={14} /> Girişe dön
        </Link>
        <h2>Şifremi unuttum</h2>
        <p className="auth-sub">Kayıtlı e-posta adresinizi girin; sıfırlama bağlantısını gönderelim.</p>

        {sent ? (
          <div className="auth-success" data-testid="forgot-success">
            <div className="auth-success-badge">
              <Mail size={18} />
            </div>
            <h3>Bağlantı gönderildi</h3>
            <p>
              E-posta adresi kayıtlıysa <strong>{email}</strong> adresine sıfırlama bağlantısını gönderdik.
              Gelen kutunuzu ve spam klasörünü kontrol edin.
            </p>
            <Link to="/login" className="primary-btn" data-testid="back-login-btn">
              Girişe dön
            </Link>
          </div>
        ) : (
          <form onSubmit={onSubmit}>
            {error ? (
              <div className="auth-error" data-testid="forgot-error">
                {error}
              </div>
            ) : null}
            <label>
              <span>E-POSTA</span>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="forgot-email-input"
                autoFocus
              />
            </label>
            <button type="submit" className="primary-btn" disabled={busy} data-testid="forgot-submit-button">
              {busy ? "Gönderiliyor…" : "Sıfırlama bağlantısı gönder"}
            </button>
          </form>
        )}
      </section>
    </div>
  );
}
